import React, { Component } from 'react'
import { connect } from 'react-redux'
import { glasConfig } from '../constants/Config'
import * as SettingMenuPremiumAction from '../actions/SettingMenuPremium'
import * as Fetch from '../util/Fetch'
import SettingMenu from './SettingMenu'
import { IconButton, Tooltip } from '@material-ui/core'
import InfoIcon from '@material-ui/icons/Info';
import { ModalSettingMenuPremium } from './Modals/Setting/ModalSettingMenuPremium'
import { Table, 
	TableBody, 
	TableCell, 
	TableContainer, 
	TableHead, 
	TableRow, 
	Paper, 
	Button, 
	Box, 
	Snackbar, 
	Alert } from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import EditIcon from '@mui/icons-material/Edit';
import MenuIcon from '@mui/icons-material/Menu';
import SettingMenuPremiumCreate from './SettingMenuPremiumCreate'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { ModalSettingMenuPremiumCreate } from './Modals/Setting/ModalSettingMenuPremiumCreate'
import { ModalSettingMenuPremiumDelete } from './Modals/Setting/ModalSettingMenuPremiumDelete'
import { ModalSettingMenuPremiumEdit } from './Modals/Setting/ModalSettingMenuPremiumEdit'
import { DeleteForever } from '@mui/icons-material'
const reorder = (list, startIndex, endIndex) => {
	const result = Array.from(list);
	const [removed] = result.splice(startIndex, 1);
	result.splice(endIndex, 0, removed);
	return result;
  };
  
class SettingMenuPremium extends Component {
	constructor(props) {
		super(props)
		this._justDragged = false;
		this.state = {
			open: false,
			isShowPopupDelete: false,
			isCreatingMenu: false,
			isShowPopupEdit:false,
			openSnackbar:false,
			editData:{},
			deleteId:'',
			nameDelete: '',
			pointRatio:[],
			datas: [],

			checked: true,
			price: '',
			menuName: '',
			description: '',
			deliveryItem: '',
			errors: {}
	
		}
		this.onDragEnd = this.onDragEnd.bind(this);
		this.resetTogglePopUpMenuPremium = this.resetTogglePopUpMenuPremium.bind(this)
		this.resetTogglePopUpMenuPremiumDelete = this.resetTogglePopUpMenuPremiumDelete.bind(this)
		this.resetTogglePopUpMenuPremiumEdit = this.resetTogglePopUpMenuPremiumEdit.bind(this)
		this.resetForm = this.resetForm.bind(this)
	}
	handleInputChange = (field, maxLength) => (e) => {
		const value = e.target.value;
		const trimmedValue = maxLength ? value.slice(0, maxLength) : value;
		this.setState((prevState) => {
			let errors = { ...prevState.errors };
			if (errors[field] && trimmedValue.trim()) {
				delete errors[field];
			}
			return {
				[field]: trimmedValue,
				errors
			};
		  });
	  };
	
	handleCheckboxChange = (checkedValue) => {
		this.setState({ checked: checkedValue });
	};
	componentWillMount() {
		const { dispatch } = this.props
		dispatch(SettingMenuPremiumAction.getAllMenuPremium())
		dispatch(SettingMenuPremiumAction.getPointRadioSetting())
	}

	componentDidUpdate(prevProps) {
		const prevData = prevProps.SettingMenuPremium.data;
		const newData = this.props.SettingMenuPremium.data;
		const isUpdatedFromRedux = JSON.stringify(prevData) !== JSON.stringify(newData);
	
		const isStateEmptyButPropsHasData = this.state.datas.length === 0 && newData.length > 0;
	
		if ((!this._justDragged && isUpdatedFromRedux) || isStateEmptyButPropsHasData) {
			this.setState({ datas: newData });
		}
		if(prevProps.SettingMenuPremium.pointRatio != this.props.SettingMenuPremium.pointRatio){
			this.setState({ pointRatio:  this.props.SettingMenuPremium.pointRatio });
		}
    }


	resetTogglePopUpMenuPremium() {
		this.setState({
			open: false
		})
	}
	resetForm()  {
		this.setState({
		  checked: true,
		  menuName: '',
		  price: '',
		  description: '',
		  deliveryItem: '',
		});
	};
	resetTogglePopUpMenuPremiumDelete() {
		this.setState({
			isShowPopupDelete: false
		})
	}
	resetTogglePopUpMenuPremiumEdit() {
		this.setState({
			isShowPopupEdit: false
		})
	}

	handleOpen = () => {
		this.setState({ open: true });
	};

	handleClose = () => {
		this.setState({ open: false });
	};

	handleOpenDelete = (id, name) => {
		this.setState({ isShowPopupDelete: true, deleteId : id , nameDelete: name});
	};
	handleCloseDelete = () => {
		this.setState({ isShowPopupDelete: false });
	};

	handleOpenEdit = (item) => {
		this.setState({ isShowPopupEdit: true ,  editData: { ...item }});
	};
	handleCloseEdit = () => {
		this.setState({ isShowPopupEdit: false });
	};


	handleCreateMenu = () => {
		if (this.state.datas.length >= 5) {
			this.setState({ openSnackbar: true });
		  } else {
			this.setState({ isCreatingMenu: true });
		  }
	};
	handleCloseSnackbar = () => {
		this.setState({ openSnackbar: false });
	};

	handleCancelCreate = () => {
		this.setState({ isCreatingMenu: false });
	};

	onDragEnd = async (result) => {
		const { dispatch } = this.props
		if (!result.destination) {
			return;
		}

		
		const datas = reorder(
			this.state.datas,
			result.source.index,
			result.destination.index
		);
	
		const extractedDataSort = {
			priorityPremiumMenuList: datas.map((item, index) => ({
				premium_menu_id: item.id, 
				order_priority: index + 1 
			}))
		};
		this._justDragged = true;
		this.setState({
			datas: datas
		})
		try {
			await dispatch(SettingMenuPremiumAction.dragMenuPremium(extractedDataSort));
			await dispatch(SettingMenuPremiumAction.getAllMenuPremium());
		} catch (error) {
			console.error("Error dragging menu premium:", error);
		} finally {
			this._justDragged = false;
		}
	

	}

	render() {
		const buttonStyle = {
			width: '700px',
			height: '52px',
			margin: '36px 107px 36px 105px',
			padding: '16px 184px 16px 185px',
			borderRadius: '4px',
			fontFamily: 'HiraKakuPro-W6',
			fontSize: '16px',
			fontWeight: '700',
			fontStretch: 'normal',
			fontStyle: 'normal',
			lineHeight: 'normal',
			letterSpacing: 'normal',
			color: '#000000de',
			textTransform: 'none',
			borderColor: '#11ad9d',
		}

		return (
			<>
				<ModalSettingMenuPremium
					isShow={this.state.open}
					resetToggle={this.resetTogglePopUpMenuPremium}
				/>

				<ModalSettingMenuPremiumDelete
					isShow={this.state.isShowPopupDelete}
					id={this.state.deleteId}
					dispatch = {this.props.dispatch}
					resetToggle={this.resetTogglePopUpMenuPremiumDelete}
					nameDelete={this.state.nameDelete}
				/>

				<ModalSettingMenuPremiumEdit
					isShow={this.state.isShowPopupEdit}
					resetToggle={this.resetTogglePopUpMenuPremiumEdit}
					data={this.state.editData}
					pointRatio={this.state.pointRatio}
					dispatch = {this.props.dispatch}
				/>

				<div className="content">
					<h1 className="content__title">設定</h1>
					<SettingMenu />
					<div className="box-shadow" style={{padding: '0 0 50px 0'}}>
						<div className="primary-title primary-title-menu-premium">
							<h3 style={{ margin: '10px 0 0' }}>プレミアムメニュー設定</h3>
							<Tooltip title="プレミアムメニューについて">
								<IconButton onClick={this.handleOpen} color="primary">
									<InfoIcon style={{ color: 'rgb(17, 173, 157)' }} />
								</IconButton>
							</Tooltip>
							<p className="primary-title__description">
								最大で5つ設定可能です
							</p>

						</div>
						{this.state.isCreatingMenu ? (
							<SettingMenuPremiumCreate onCancel={this.handleCancelCreate}  menuName={this.state.menuName}
							price={this.state.price}
							description={this.state.description}
							deliveryItem={this.state.deliveryItem}
							checked={this.state.checked}
							errors={this.state.errors}
							handleInputChange={this.handleInputChange}
							handleCheckboxChange={this.handleCheckboxChange} pointRatio={this.state.pointRatio}
							resetForm = {this.resetForm}
							/>
						) : (
							<>
								<div className='flex-button-title-menu-premium'>
									<Button
										variant="outlined"
										endIcon={<KeyboardArrowDownIcon sx={{ color: '#11ad9d' , fontSize: '35px !important' }} />}
										style={buttonStyle}
										onClick={this.handleCreateMenu}
									>
										新しいプレミアムメニューを追加する
									</Button>
								</div>
								<hr className='inline'></hr>
								<div className="primary-title1-menu-premium">
									<p>メニューの修正・削除・並び替えができます。</p>
									<p>修正時は再審査が行われます。</p>
								</div>
								<div>
									<Box sx={{ width: '100%' }}>
										<DragDropContext onDragEnd={this.onDragEnd}>
											<Droppable droppableId="premium-menu-list">
												{(provided) => (
													<TableContainer sx={{ boxShadow: 'none'}} component={Paper} ref={provided.innerRef} {...provided.droppableProps}>
														<Table sx={{ width: '95%', margin: '0 auto' }}>
															<TableBody>
																{this.state.datas.map((item, index) => (
																	<Draggable key={item.id} draggableId={item.id} index={index}>
																		{(provided, snapshot) => (
																			<TableRow
																				ref={provided.innerRef}
																				{...provided.draggableProps}
																				{...provided.dragHandleProps} 
																				sx={{
																					bgcolor: item.status === 1 
																					? '#dadada' 
																					: snapshot.isDragging 
																					  ? 'rgba(17, 173, 157, 0.1)' 
																					  : 'inherit',
																					'&:hover': {
																						bgcolor: item.status === 1 
																						? '#f0f0f0'
																						: 'rgba(17, 173, 157, 0.05)',
																					},

																					borderTop: '1px solid #e0e0e0',
																					borderBottom: '1px solid #e0e0e0'
																				}}
																			>
																				<TableCell  sx={{ 
																							width: '65%',
																							padding: '30px 70px 30px 70px'
																						}}>
																					<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
																						<Box className="flex-menu-premium-list">
																							<Box component="p" sx={{ color: "#11ad9d", fontWeight: '700', m: 0 , fontSize:'16px'}}>
																								{item.title}
																							</Box>
																							<Box component="p"  sx={{ fontWeight: '700' }}>
																								{(item.amount).toLocaleString()}pts
																							</Box>
																							<Box component="p">
																								{item.is_deliverable ? '納品物 : ' + item.deliverable_note : '納品物 : なし'}
																							</Box>
																						</Box>
																						<Box component="p" sx={{ m: 0, fontSize: '0.875rem', whiteSpace: 'pre-line' }}>
																							{item.description}
																						</Box>
																					</Box>
																				</TableCell>
																				<TableCell sx={{ 
																							width: '20%',
																							padding: '30px 70px 30px 70px' 
																							}}>
																					<Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'center' }}>
																						<Button
																							onClick={()=>this.handleOpenEdit(item)}
																							variant="outlined"
																							startIcon={<EditIcon sx={{  color: '#757575',
																								position: 'absolute',
																								left: '12px', 
																								top: '50%',
																								transform: 'translateY(-50%)' }} />}
																							sx={{
																								pointerEvents: item.status === 1 ? 'none' : 'auto',
																								width: '200px',
																								borderColor: '#e4e4e4',
																								color: '#666',
																								fontSize: '12px',
																								backgroundColor: '#f9f9f9',
																								'&:hover': {
																									borderColor: '#ccc',
																									bgcolor: 'rgba(0, 0, 0, 0.04)'
																								}
																							}}
																						>
																							修正
																						</Button>
																						<Button
																							onClick={() => this.handleOpenDelete(item.id, item.title)}
																							variant="outlined"
																							startIcon={<DeleteForever
																								sx={{ color: '#eb4646' , position: 'absolute',
																								left: '12px', 
																								top: '50%',
																								transform: 'translateY(-50%)'}} />}
																							sx={{
																								pointerEvents: item.status === 1 ? 'none' : 'auto',
																								width: '200px',
																								border: 'solid 1px #e4e4e4',
																								fontSize: '12px',
																								backgroundColor: '#f9f9f9',
																								color: '#eb4646',
																								'&:hover': {
																									borderColor: '#d32f2f',
																									bgcolor: 'rgba(235, 70, 70, 0.04)'
																								}
																							}}
																						>
																							削除
																						</Button>
																					</Box>
																				</TableCell>
																				<TableCell sx={{ 
																							width: '10%',
																							padding: '30px 70px 30px 70px',
																							pointerEvents: 'auto' }}>
																					<div {...provided.dragHandleProps}>
																						<IconButton
																							sx={{
																								border: '2px solid #11ad9d',
																								borderRadius: '8px',
																								color: '#11ad9d',
																								backgroundColor: '#ffffff',
																								boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
																								cursor: 'grab'
																							}}
																						>
																							<MenuIcon />
																						</IconButton>
																					</div>
																				</TableCell>
																			</TableRow>
																		)}
																	</Draggable>
																))}
																{provided.placeholder}
															</TableBody>
														</Table>
													</TableContainer>
												)}
											</Droppable>
										</DragDropContext>
									</Box>
								</div>
							</>
						)}
						{this.state.datas.length == 0 && <div>
							<p className='primary-title1-menu-premium' style={{ color: '#9e9e9e' }}>まだメニューは登録されていません</p>
						</div>}
					</div>
				</div>
				<Snackbar
					open={this.state.openSnackbar}
					autoHideDuration={2000}
					onClose={this.handleCloseSnackbar}
					anchorOrigin={{ vertical: "top", horizontal: "right" }} 
					>
					<Alert onClose={this.handleCloseSnackbar} severity="error">
						プレミアムメニューは最大5つまでです。
					</Alert>
				</Snackbar>
			</>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		SettingMenuPremium: state.SettingMenuPremium,
	}
}

export default connect(mapStateToProps)(SettingMenuPremium)
